import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {IIncoming} from '../../shared/model/incoming.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {IFactor} from "../../shared/model/factor.model";
import {IProject} from "../../shared/model/project.model";


type EntityResponseType = HttpResponse<IIncoming>;
type EntityArrayResponseType = HttpResponse<IIncoming[]>;

@Injectable({providedIn: 'root'})
export class IncomingService {
  public resourceUrl = SERVER_API_URL + 'api/incomings';

  constructor(protected http: HttpClient) {
  }

  create(incoming: IIncoming): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(incoming);
    return this.http
      .post<IIncoming>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(incoming: IIncoming): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(incoming);
    return this.http
      .put<IIncoming>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IIncoming>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<IIncoming[]>(this.resourceUrl, {params: options, observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findWithPrjId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl + '-project/'+id, {params: options, observe: 'response'});
  }

  findWithOrderId(req?: any, id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl + '-order/' + id, {params: options, observe: 'response'});
  }

  findWithPrjIdWithSupplier(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl + '-project-supplier/'+id, {params: options, observe: 'response'});
  }

  findWithPrjIdWithInstaller(req?: any, id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl + '-project-installer/' + id, {params: options, observe: 'response'});
  }

  findWithSupplierId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl + '-supplier/'+id, {params: options, observe: 'response'});
  }

  findWithInstallerId(req?: any, id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl + '-installer/' + id, {params: options, observe: 'response'});
  }

  findMyIncomingCount(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {observe: 'response'});
  }

  findMyIncoming(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IIncoming[]>(`${this.resourceUrl + '-self'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findIncomingTransaction(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IIncoming[]>(`${this.resourceUrl + '-transaction'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
  findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IIncoming[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  protected convertDateFromClient(incoming: IIncoming): IIncoming {
    const copy: IIncoming = Object.assign({}, incoming, {
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((incoming: IIncoming) => {
      });
    }
    return res;
  }


  getCountIncomingForProject(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-project-count', {params: options, observe: 'response'});
  }

  getCountIncomingTotal(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-total-count', {params: options, observe: 'response'});
  }

  getCountIncomingTotalSettled(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-total-count-settled', {params: options, observe: 'response'});
  }

  getCountIncomingForProjectByStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-project-status-count', {params: options, observe: 'response'});
  }

  getCountIncomingTotalWithupplier(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-total-supplier-count', {params: options, observe: 'response'});
  }

  getCountIncomingTotalWithupplierSettled(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-total-supplier-count-settled', {params: options, observe: 'response'});
  }

  findIncomingSumSuppliers(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-sum-supplier/' + param}`, {observe: 'response'});
  }

  findIncomingTotalPeriod(param: any): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-sum-total-period/' + param}`, {observe: 'response'});
  }

  getCountIncomingForProjectWithupplier(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-project-supplier-count', {params: options, observe: 'response'});
  }

  getCountIncomingForProjectWithInstaller(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-project-installer-count', {params: options, observe: 'response'});
  }

  getCountIncomingForupplier(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-supplier-count', {params: options, observe: 'response'});
  }

  getCountIncomingForInstaller(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-installer-count', {params: options, observe: 'response'});
  }

  getCountIncomingForProjectWithupplierByStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl + '-project-supplier-status-count', {params: options, observe: 'response'});
  }

  searchReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IIncoming[]>(this.resourceUrl+'-search-report', {params: options, observe: 'response'});
  }
  searchReportCount(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl+'-search-report-count', {params: options, observe: 'response'});
  }
}
